import {MaterialNode} from "#material/nodes/base/material/material-node"
import type {TexBrickSockets} from "#material/nodes/texture/tex-brick/definition"
import {texBrickDefinition} from "#material/nodes/texture/tex-brick/definition"
import type {CyclesReturns} from "#material/sockets/cycles"
import {threeRGBColor, threeValue} from "#material/three/three-utils"
import type {CyclesEvaluator, ThreeEvaluator} from "#material/nodes/base/material/types/evaluators"
import {registerMaterialGraphNode} from "#material/register"
import {cyclesColor} from "#material/cycles/helpers"
import type {ThreeReturns} from "#material/sockets/three"
import type {BrickTextureNode} from "#material/cycles/types"

@registerMaterialGraphNode
export class TexBrick extends MaterialNode<TexBrickSockets> {
    public override get definition() {
        return texBrickDefinition
    }

    override toThree = async (evaluator: ThreeEvaluator): Promise<ThreeReturns<TexBrickSockets>> => {
        const {logger} = evaluator.context
        logger.warn("WARNING: Tex brick node not fully implemented!")
        return {color: threeRGBColor({r: 0, g: 0, b: 0}), fac: threeValue(0)}
    }

    override toCycles = async (evaluator: CyclesEvaluator): Promise<CyclesReturns<TexBrickSockets>> => {
        const brickTextureNode: BrickTextureNode = {
            type: "brick_texture",
            inputs: await evaluator.getAll({
                bias: this.parameters.inputs.bias,
                brick_width: this.parameters.inputs.brickWidth,
                color1: this.parameters.inputs.color1,
                color2: this.parameters.inputs.color2,
                mortar: this.parameters.inputs.mortar,
                mortar_size: this.parameters.inputs.mortarSize,
                mortar_smooth: this.parameters.inputs.mortarSmooth,
                row_height: this.parameters.inputs.rowHeight,
                scale: this.parameters.inputs.scale,
                vector: this.parameters.inputs.vector,
            }),
            parameters: {
                bias: this.parameters.settings.bias,
                brick_width: this.parameters.settings.brickWidth,
                color1: cyclesColor(this.parameters.settings.color1),
                color2: cyclesColor(this.parameters.settings.color2),
                mortar: cyclesColor(this.parameters.settings.mortar),
                mortar_size: this.parameters.settings.mortarSize,
                mortar_smooth: this.parameters.settings.mortarSmooth,
                row_height: this.parameters.settings.rowHeight,
                offset: this.parameters.settings.offset,
                offset_frequency: this.parameters.settings.offsetFrequency,
                scale: this.parameters.settings.scale,
                squash: this.parameters.settings.squash,
                squash_frequency: this.parameters.settings.squashFrequency,
            },
            resources: {},
        }

        return {color: [brickTextureNode, "color"], fac: [brickTextureNode, "fac"]}
    }
}
